import {version} from 'package.json';
export const environment = {
  production: true,
  url_api_sisrh: 'https://sisrhapi.sestsenat.org.br/',
  url_api_lgpd: 'https://lgpd.sestsenat.org.br/',
  url_api_sistema_prova: 'https://processoseletivo.sestsenat.org.br/',
  versao: version,
  urlVersionFile: 'https://candidato.sestsenat.org.br/version.json'
};
